'use client';

import { LoadingOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import { useState } from 'react';
import { SemiboldBody } from './typography';

const primaryButtonStyle = (height: string, width: string) => {
	return {
		height,
		borderRadius: '8px',
		fontWeight: 600,
		fontSize: '14px',
		lineHeight: '20px',
		width: width ? width : '',
	};
};

const secondaryButtonStyle = (isHovered: boolean, height: string) => {
	return {
		background: isHovered ? '#F9F5FF' : '#FFFFFF',
		borderRadius: '8px',
		transition: 'background 0.3s',
		cursor: 'pointer',
		height,
		color: '#7F56D9',
		border: '1px solid #D6BBFB',
		fontWeight: 600,
		fontSize: '14px',
		lineHeight: '20px',
	};
};

const tertiaryButtonStyle = (isHovered: boolean, height: string, disabled: boolean) => {
	return {
		background: isHovered ? '#F9FAFB' : '#FFFFFF',
		disabled: disabled,
		borderRadius: '8px',
		transition: 'background 0.3s',
		cursor: 'pointer',
		height,
		color: '#182230',
		border: '1px solid #D0D5DD',
		fontWeight: 600,
		fontSize: '14px',
		lineHeight: '20px',
	};
};
export const RegularPrimaryButton = ({
	text,
	handleClick,
	width,
	disabled,
}: {
	text: any;
	handleClick: any;
	width: string;
	disabled: boolean;
}) => {
	return (
		<Button type='primary' style={primaryButtonStyle('36px', width)} onClick={handleClick} disabled={disabled}>
			{text}
		</Button>
	);
};
export const MediumPrimaryButton = ({ text, handleClick ,disabled}: { text: string; handleClick: any ; disabled?:boolean}) => {
	return (
		<Button type='primary' style={primaryButtonStyle('40px', '')} onClick={handleClick} disabled={disabled}>
			{text}
		</Button>
	);
};
export const LargePrimaryButton = ({
	text,
	handleClick,
	style,
	disabled,
	loading,
}: {
	text: string;
	handleClick: any;
	style?: any;
	disabled?: any;
	loading?: boolean;
}) => {
	const mergedStyles = { ...primaryButtonStyle('44px', ''), ...style };

	return (
		<Button 
			type='primary' 
			style={mergedStyles} 
			onClick={handleClick} 
			onTouchStart={handleClick}
			disabled={disabled}
		>
			{loading ? (
				<Spin indicator={<LoadingOutlined spin style={{ color: 'white !important' }} />} size='small' />
			) : (
				text
			)}
		</Button>
	);
};

export const RegularSecondaryButton = ({ text, handleClick }: { text: string; handleClick: any }) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => {
		setIsHovered(true);
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	return (
		<Button
			style={secondaryButtonStyle(isHovered, '36px')}
			onMouseEnter={handleMouseEnter}
			onClick={handleClick}
			onMouseLeave={handleMouseLeave}
		>
			{text}
		</Button>
	);
};

export const MediumSecondaryButton = ({ text, handleClick }: { text: string; handleClick: any }) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => {
		setIsHovered(true);
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	return (
		<Button
			style={secondaryButtonStyle(isHovered, '40px')}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
		>
			{text}
		</Button>
	);
};

export const LargeSecondaryButton = ({ text, handleClick }: { text: string; handleClick: any }) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => {
		setIsHovered(true);
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	return (
		<Button
			style={secondaryButtonStyle(isHovered, '44px')}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
		>
			{text}
		</Button>
	);
};

export const RegularTertiaryButton = ({
	text,
	handleClick,
	disabled,
}: {
	text: any;
	handleClick: any;
	disabled: boolean;
}) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => {
		setIsHovered(true);
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
	};
	return (
		<Button
			style={tertiaryButtonStyle(isHovered, '36px', disabled)}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
		>
			{text}
		</Button>
	);
};
export const MediumTertiaryButton = ({ text, handleClick, disabled }: { text: any; handleClick: any; disabled: boolean }) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => {
		setIsHovered(true);
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
	};
	return (
		<Button
			style={tertiaryButtonStyle(isHovered, '40px', disabled)}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
		>
			{text}
		</Button>
	);
};
export const LargeTertiaryButton = ({ text, handleClick, disabled }: { text: any; handleClick: any; disabled: boolean }) => {
	const [isHovered, setIsHovered] = useState(false);
	const handleMouseEnter = () => {
		setIsHovered(true);
	};
	const handleMouseLeave = () => {
		setIsHovered(false);
	};
	return (
		<Button
			style={tertiaryButtonStyle(isHovered, '44px', disabled)}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
		>
			{text}
		</Button>
	);
};

export const PrimaryCustomButton = ({ text, leftIcon, leftIconStyle, containerStyle, rightText, rightTextStyle, rightIcon, rightIconStyle,textStyle, handleClick }: { text: string; leftIcon: any; leftIconStyle: {}; containerStyle: {}; rightText: string; rightTextStyle: {}; rightIcon: any; rightIconStyle: {}; textStyle: {}; handleClick: any }) => {
	return (
		<Button type='default' style={containerStyle} onClick={handleClick} >
			<div className='flex items-center'>
				<img src={leftIcon} style={leftIconStyle} />
				<SemiboldBody text={text} style={textStyle} />
			</div>
			<div className='flex items-center'>
				<SemiboldBody text={rightText} style={rightTextStyle} />
				<img src={rightIcon} style={rightIconStyle} />
			</div>
		</Button>
	);
};
